(function($){

$(function() {
    setTimeout(function() {
        $('.page-errors').fadeOut();
    }, 5000);
});

})(jQuery);
